import { useTranslation } from 'react-i18next';
import { StepCardOld } from 'pages/AutomationEngine/Engine/Steps/StepCardOld';
import { useContext } from 'react';
import { FlowBuilderContext } from '../../context';
import { FlowStep } from '../../types';
import { type AdditionalVariable } from 'pages/SmartConnectors/types';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';

type StepProps = {
  step: FlowStep & { details: { additional_variables: AdditionalVariable[] } };
  color: string;
  title: string;
};

export default function InitializeAdditionalVariablesCard({
  step,
  color,
  title,
  ...others
}: StepProps) {
  const { t } = useTranslation();
  const { dropStep, flowErrors } = useContext(FlowBuilderContext);
  const { additional_variables } = step.details;

  const stepErrors = flowErrors.flow.additional_variables || [];
  const hasErrors = stepErrors.some(
    (errors) => Object.values(errors || {}).length
  );

  return (
    <StepCardOld
      {...others}
      id={step.id}
      panel={null}
      color={hasErrors ? 'var(--color-button-warning-hover)' : color}
      borderColor={hasErrors ? 'var(--color-button-warning-hover)' : null}
      showMovingPlaceholder={false}
      title={title}
      onSelectMenu={() => {
        dropStep({ step, ...(others as any) });
      }}
      editOnly
    >
      <TextEllipsisWithTooltip>
        {t('Set Values for {{amount}} Variable(s)', {
          amount: additional_variables?.length || 0,
        })}
      </TextEllipsisWithTooltip>
    </StepCardOld>
  );
}
